module.exports = __webpack_public_path__ + "img/hhc.ab5cebef.jpeg";